// JsFromRoutes CacheKey 6502968ef4bfd39d845baf7426c247b7
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@consumer/services/api'

export default {
  create: /* #__PURE__ */ definePathHelper('post', '/testing_tools/places/:place_id/gift_tips'),
  update: /* #__PURE__ */ definePathHelper('patch', '/testing_tools/places/:place_id/gift_tips/:id'),
  destroy: /* #__PURE__ */ definePathHelper('delete', '/testing_tools/places/:place_id/gift_tips/:id'),
}
